import { Directive, ElementRef, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { Platform } from '@bca-core/models/_enums';
import { BCA_PLATFORM } from '@bca-core/models/platform';

@Directive({
  selector: '[cypress]'
})
export class CypressDirective implements OnInit {
  @Input()
  cypress: string;

  private readonly _cypressPlatforms = Array(
    Platform.ACCEPTANCE,
    Platform.TEST,
    Platform.TEST2,
    Platform.TESTAUT,
    Platform.DEVELOPMENT
  );

  constructor(
    @Inject(BCA_PLATFORM) private _platform: Platform,
    private _hostElement: ElementRef,
    private _renderer: Renderer2
  ) {}

  ngOnInit(): void {
    const { cypress, _platform: platform } = this;

    if (!cypress || !this._cypressPlatforms.includes(platform)) {
      return;
    }

    this._renderer.setAttribute(this._hostElement.nativeElement, 'data-cy', cypress);
  }
}
